export default {
    reopenCardFailure: {
        dataTrackId: 'reopen-card-failure',
        dataTrackLinkname: 'gjenapne kort feil',
    },
    reopenCardSuccess: {
        dataTrackId: 'reopen-card-success',
        dataTrackLinkname: 'gjenapne kort suksess',
    },
    reopenCard: {
        dataTrackId: 'reopen-card',
        dataTrackLinkname: 'gjenapne kort',
    },
    reopenCardModal: {
        dataTrackId: 'reopen-card-modal',
        dataTrackLinkname: 'modal gjenapne kort',
    },
};
